import {ApiConfigurationObj} from './ApiConfigurationObj';
import {AuthApiConfigurationObj} from './AuthApiConfigurationObj';
import {DatabaseConfigurationObj} from './DatabaseConfigurationObj';
import {FtpConfigurationObj} from './FtpConfigurationObj';

export class ConnectionConfigurationObj {
api: ApiConfigurationObj;
authApi: AuthApiConfigurationObj;
bdd: DatabaseConfigurationObj;
ftp: FtpConfigurationObj;
host: string;
}

